var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");
